module.exports = __webpack_public_path__ + "img/offline-denmark.890d8885.png";